/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { useEditUserMutation } from "../../features/apiSlice"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import Table from "./Components/Table"
import TopBar from "../../components/TopBar"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import { useGetOrganizationsQuery } from "../../features/organizationSlice"
import { useExportOrganizationsMutation } from "../../features/organizationSlice"
import OrganizationAdvancedSearch from "./Components/AdvancedSearch"
import { resetOrganizationSearch, setOrgSearchApplied } from "../../redux/organizationSearchSlice"
import { handleSidebarPrvState } from "../../redux/systemConfigSlice"

export default function ManageOrganization() {
    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar, setIsSideBar, isAdvancedSearchOpen, setIsAdvancedSearchOpen } = useContext(GlobalContext);

    const [editUser] = useEditUserMutation()
    const [exportOrganizations] = useExportOrganizationsMutation()
    const [suggestions, setSuggestions] = useState("")
    const [limit, setLimit] = useState("15")
    const [skip, setSkip] = useState(true)
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [isSortselected, setisSortSelected] = useState(false)
    const [datePartialFilled, setDatePartialFilled] = useState(false)
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const organizationSearch = useSelector(state => state.organizationSearchData);
    const searchApplied = useSelector((state) => state.organizationSearchData.orgsearchApplied);


    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const { data, isFetching, isLoading, status } = useGetOrganizationsQuery(searchParams?.toString(), { skip: skip || location.search === '' })
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
        }
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }
    useEffect(() => {
        if (location.search === '') {
            setSkip(true);  // Handle empty query scenario
        }

        // If there is a valid state object in location
        if (location.state !== null && location.state !== '' && !Array.isArray(location.state)) {
            const params = { limit: '15', page_number: '1', sort: 'created_at+desc', ...location.state }
            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search
            setSearchParams(params)
            if (params.search_mode && !isAdvancedSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsAdvancedSearchOpen(true)
                setIsSideBar(false)
            }
        } else {
            // Only initialize default values if no search params exist
            const params = Object.fromEntries(searchParams)
            let changed = false
            if (!params.limit) { params.limit = '15'; changed = true }
            if (!params.page_number) { params.page_number = '1'; changed = true }
            if (!params.sort) { params.sort = 'created_at+desc'; changed = true }
            if (changed) setSearchParams(params, { replace: true })
        }

        // Set suggestions based on the search query
        setSuggestions(
            searchParams.get('search')
                ? decodeURIComponent(searchParams.get('search'))
                : ''
        );

    }, [location]);

    useEffect(() => {
        if (searchParams.size >= 3) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])



    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }
    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }


    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)

    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );


    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();

        let searchString = '';

        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `user_id` and `user_id_inverse` conditions
        if (organizationSearch?.user_id && organizationSearch?.user_id.trim() !== '') {
            const userIdPrefix = organizationSearch?.user_id_inverse ? 'ne:' : '';
            const formattedUserId = formatSearchValue(organizationSearch.user_id);
            searchString += `organization_id=${userIdPrefix}${encodeURIComponent(formattedUserId)};`;
        }

        // Check for `orgname` and `orgname_inverse` conditions
        if (organizationSearch?.orgname && organizationSearch?.orgname.trim() !== '') {
            const orgNamePrefix = organizationSearch?.orgname_inverse ? 'ne:' : '';
            const formattedOrgName = formatSearchValue(organizationSearch?.orgname);
            searchString += `organization_name=${orgNamePrefix}${encodeURIComponent(formattedOrgName)};`;
        }

        // Check for `main_number` and `main_number_inverse` conditions
        if (organizationSearch?.main_number_code || organizationSearch?.main_number) {
            const mainNumPrefix = organizationSearch.main_number_inverse ? 'ne:' : '';
            const mainCountryCode = formatSearchValue(organizationSearch?.main_number_code || '');
            const mainNumber = formatSearchValue(organizationSearch?.main_number || '');
            searchString += `organization_main_country_code-main_number=${mainNumPrefix}${mainCountryCode ? '+' : ''}${encodeURIComponent(mainCountryCode)}-${encodeURIComponent(mainNumber)};`;
        }

        // Handle `value_added` with optional inverse condition
        if (Array.isArray(organizationSearch.value_added)) {
            const valueAddedPrefix = organizationSearch.value_added_inverse ? 'ne:' : '';
            organizationSearch.value_added.forEach(type => {
                searchString += `value_added=${valueAddedPrefix}${encodeURIComponent(type)};`;
            });
        }
        // Handle `direct_billing` with optional inverse condition
        if (Array.isArray(organizationSearch.direct_billing)) {
            const valueAddedPrefix = organizationSearch.direct_billing_inverse ? 'ne:' : '';
            organizationSearch.direct_billing.forEach(type => {
                searchString += `direct_billing=${valueAddedPrefix}${encodeURIComponent(type)};`;
            });
        }

        const { created_day, created_month, created_year } = organizationSearch || {};
        // Check if only some of the fields are filled
        const isPartialDateFilled = (created_day && (!created_month || !created_year)) || (created_month && (!created_day || !created_year)) || (created_year && (!created_day || !created_month));

        if (isPartialDateFilled) {
            setDatePartialFilled(true);
            return;
        } else if (created_day && created_month && created_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;

            // Create a Date object in the browser's timezone at midnight
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds (local timezone)
            const epochDate = Math.floor(date.getTime() / 1000);
            const createdDatePrefix = organizationSearch.created_date_inverse ? 'ne:' : '';

            // Add epoch to search string
            searchString += `created_at=${createdDatePrefix}${epochDate};`;
        }


        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;

        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: organizationSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            sort: currentParams.sort || 'created_at+desc', // Keep sort or set default
            limit: currentParams.limit || '15', // Keep limit or set default
        };

        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;

        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setOrgSearchApplied());

    };

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetOrganizationSearch());
        }
    }, [dispatch, searchApplied]);

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Organizations"} />
                <div className='bg-white rounded-lg pt-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBar
                            title={'List of Organizations'}
                            organization={true}
                            AddButton={(data === undefined) ? false : true}
                            SearchInput={((data?.data?.length === 0 && suggestions === "") || data === undefined) ? false : true}
                            SearchPlaceholder={'Search by Org Name, ID etc'}
                            buttonName={"Add Organization"}
                            toAddScreen={'/manage-organizations/add-organization'}
                            menuBar={(data !== undefined && data?.data?.length > 0 && selectedRows?.length > 0) ? true : false}
                            ApplyFilter={false}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID', 'Organization Name', 'Main Number', 'Value Added', 'Direct Billing', 'Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportUsers={exportOrganizations}
                            isIdexport={false}
                            searchAdminCorporate={true}
                        />
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected" && !isSortselected) || (isLoading) || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading organizations list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay' : 'overlay-list'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                            />
                        </div>
                        {data?.total_count >= 15 && <div className="w-[100%] px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />

                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    limit={parseInt(searchParams.get('limit'))}
                                />
                            </div>
                        </div>}
                    </> : <>
                        {(data?.total_count === 0 && suggestions?.trim() !== "") || (data?.success_status === "false") ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count === 0 && !searchParams.get("search") ? <Emptyscreen
                                title={"Manage Organizations"}
                                FirstPTag={"No Organization added yet."}
                                SecondePTag={"Start managing by clicking 'Add Organization'"}
                            /> : ((status === "rejected" || (data?.total_count !== 0 && data?.data?.length === 0)) && <SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
            </div>
            {isAdvancedSearchOpen && searchParams?.get('limit') &&
                <OrganizationAdvancedSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                />
            }
        </>

    )
}